export const version = 'v1.1.5'
export const copyright = "© We're Not Really Strangers"
export const developer = "jonathan-lph"
export const contact = "If there is bug or typo,\n please contact through GitHub."